import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, CardBody, Badge, Button } from "reactstrap";
import { Link } from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import api from "./../../../Api.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";

/**
 * DmLobby — lobby do professor (Mestre do Jogo).
 * Lista as turmas que o professor pode reger e leva pro painel do mestre.
 */
class DmLobby extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classrooms: [],
      sessions: {}, // { [classroomId]: true|false }
      loading: true
    };
  }

  async componentDidMount() {
    await this.loadClassrooms();
  }

  notify(type, title, message) {
    try {
      this.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: <div className="alert-text"><span className="alert-title">{title}</span><span> {message}</span></div>,
        type: type, icon: 'ni ni-bell-55', autoDismiss: 5
      });
    } catch (e) {}
  }

  async loadClassrooms() {
    var classrooms = [];
    try {
      var res = await api.getMyClassRooms();
      classrooms = Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      this.notify('danger', 'Ops!', 'Não consegui carregar suas turmas. Tenta de novo em instantes.');
    }

    // Professor/admin pode reger qualquer turma: fallback pra lista completa
    if (classrooms.length === 0) {
      try {
        var resAll = await api.getAllClassRoom();
        classrooms = Array.isArray(resAll.data) ? resAll.data : [];
      } catch (e) {
        // se o fallback também falhar, segue com lista vazia (estado vazio amigável)
      }
    }

    this.setState({ classrooms: classrooms, loading: false });
    await this.checkSessions(classrooms);
  }

  setSessionStatus(classroomId, active) {
    this.setState(function (prev) {
      var sessions = Object.assign({}, prev.sessions);
      sessions[classroomId] = active;
      return { sessions: sessions };
    });
  }

  async checkSessions(classrooms) {
    var self = this;
    await Promise.all(classrooms.map(async function (classroom) {
      try {
        var res = await api.getActiveSession(classroom.id);
        self.setSessionStatus(classroom.id, !!(res.data && res.data.active));
      } catch (e) {
        // erro pontual: trata como sem sessão, sem quebrar o lobby
        self.setSessionStatus(classroom.id, false);
      }
    }));
  }

  getSortedClassrooms() {
    var sessions = this.state.sessions;
    return this.state.classrooms.slice().sort(function (a, b) {
      var liveA = sessions[a.id] ? 1 : 0;
      var liveB = sessions[b.id] ? 1 : 0;
      return liveB - liveA; // sessão ativa primeiro
    });
  }

  render() {
    var sorted = this.getSortedClassrooms();

    return (
      <React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        {!this.props.embedded && <SimpleHeader name="🐉 Mestre do Jogo" way={[{ name: "Mestre do Jogo", url: "/dm" }]} />}

        <Container className={this.props.embedded ? "mt-3" : "mt--6"} fluid>
          {/* Header explicativo */}
          <Card className="shadow mb-3">
            <CardBody className="text-center">
              <h3 className="mb-1">
                <i className="fas fa-crown mr-2 text-warning" />
                Sala do Mestre do Jogo
              </h3>
              <p className="mb-0 text-muted">Escolha uma turma, invoque os monstros e comande a aventura! 🎲</p>
            </CardBody>
          </Card>

          {this.state.loading ? (
            <div className="text-center py-5"><i className="fas fa-spinner fa-spin fa-2x text-muted" /></div>
          ) : sorted.length === 0 ? (
            <Card className="shadow">
              <CardBody className="text-center py-5">
                <i className="fas fa-scroll fa-3x text-muted mb-3" />
                <h4>Nenhuma turma pra reger por aqui 📜</h4>
                <p className="text-muted mb-0">Quando você tiver turmas disponíveis, elas aparecem aqui pra você assumir o trono!</p>
              </CardBody>
            </Card>
          ) : (
            <Row>
              {sorted.map((classroom) => {
                var live = !!this.state.sessions[classroom.id];
                return (
                  <Col xs="12" sm="6" md="4" lg="3" key={classroom.id} className="mb-3">
                    <Card className="shadow h-100" style={{ border: live ? '2px solid #2dce89' : '1px solid #e9ecef' }}>
                      <CardBody className="text-center d-flex flex-column">
                        <div style={{ fontSize: '2rem' }}>🏰</div>
                        <h5 className="mt-2 mb-2" style={{ color: '#32325d' }}>
                          {classroom.name || ('Turma #' + classroom.id)}
                        </h5>
                        <div className="mb-3">
                          {live ? (
                            <Badge pill style={{ background: '#2dce89', color: '#fff', fontSize: '0.75rem' }}>
                              ⚔️ Sessão ativa
                            </Badge>
                          ) : (
                            <Badge pill color="secondary" style={{ fontSize: '0.75rem' }}>
                              💤 Sem sessão
                            </Badge>
                          )}
                        </div>
                        <div className="mt-auto">
                          <Button
                            tag={Link}
                            to={"/dm/" + classroom.id}
                            color={live ? 'success' : 'primary'}
                            size="sm"
                            block
                          >
                            Assumir o trono 🐉
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          )}
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({ user: state.user }))(DmLobby);
